module.exports = __webpack_public_path__ + "static/media/iconoUsuario.2f243cc1.png";